var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShannonLau(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "297.553px",
    height: "297.546px",
    viewBox: "-13.776 0 297.553 297.546",
    enableBackground: "new -13.776 0 297.553 297.546",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M202.501,3.99v55.353c0,3.516-0.012,6.471-4.113,8.529L67.5,133.313l62.461,31.229 c3.633,1.943,3.556,3.273,0.144,4.967l-58.876,29.438c-3.259,1.523-4.195,1.547-7.61-0.076L2.744,168.436 C0.799,167.427,0,166.339,0,162.224v-58.83c0-1.996,0.818-4.336,3.203-5.431l194.338-97.17 C200.581-0.668,202.501-0.382,202.501,3.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F5FAC",
    d: "M129.961,164.542c3.633,1.944,3.556,3.274,0.144,4.967l-58.876,29.439 c-3.259,1.522-4.195,1.545-7.61-0.078L0,167.063l67.5-33.75L129.961,164.542"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#128CFF",
    points: "0,99.563 0,167.063 67.5,133.313  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FD6FF",
    d: "M202.501,3.99v55.353c0,3.516-0.012,6.471-4.113,8.529L67.5,133.313L0,99.563L197.542,0.792 C200.581-0.668,202.501-0.382,202.501,3.99"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M67.5,293.556v-55.354c0-3.517,0.011-6.472,4.11-8.527l130.89-65.442l-62.462-31.23 c-3.634-1.944-3.558-3.273-0.146-4.966l58.876-29.439c3.262-1.523,4.197-1.545,7.613,0.077l60.874,30.436 c1.943,1.009,2.742,2.097,2.742,6.213v58.83c0,1.994-0.82,4.336-3.201,5.432l-194.34,97.17 C69.419,298.212,67.5,297.928,67.5,293.556"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F5FAC",
    d: "M140.039,133.001c-3.633-1.944-3.558-3.273-0.146-4.966l58.876-29.439 c3.263-1.523,4.197-1.545,7.613,0.077l63.618,31.809l-67.5,33.75L140.039,133.001"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#128CFF",
    points: "270.001,197.981 270.001,130.482 202.501,164.232  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FD6FF",
    d: "M67.5,293.556v-55.354c0-3.517,0.011-6.472,4.11-8.527l130.89-65.442l67.5,33.749l-197.542,98.77 C69.419,298.212,67.5,297.928,67.5,293.556"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShannonLau);
export default __webpack_public_path__ + "static/media/shannon-lau.8dd64454b65a7fac88e7657cd676cb4d.svg";
export { ForwardRef as ReactComponent };